module.exports = __webpack_public_path__ + "static/16-bc9c320f7e56cda593fcafb6adcd5740.jpg";